import { render, staticRenderFns } from "./ProjectsStats.vue?vue&type=template&id=0914c596&scoped=true"
import script from "./ProjectsStats.vue?vue&type=script&lang=ts"
export * from "./ProjectsStats.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsStats.vue?vue&type=style&index=0&id=0914c596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914c596",
  null
  
)

export default component.exports